import { useCallback, useEffect, useMemo, useState } from 'react'
import ImgTeacher1 from '../assets/teacher-1.png'
import ImgTeacher2 from '../assets/teacher-2.png'
import ImgTeacher3 from '../assets/teacher-3.png'
import ImgTeacher4 from '../assets/teacher-4.png'
import ImgTeacher5 from '../assets/teacher-5.png'
import ImgTeacher6 from '../assets/teacher-6.png'
import ImgTeacher7 from '../assets/teacher-7.png'
import ImgTeacher8 from '../assets/teacher-8.png'
import ImgTeacher9 from '../assets/teacher-9.png'
import ImgTeacher10 from '../assets/teacher-10.png'

interface IUseImageSlider {
  (): {
    activeElement: string | null
    items: string[]
    onClick: (index: number, img: string) => void
    activeIndex: number
  }
}

let timerKey = 0

export const useImageSlider: IUseImageSlider = () => {
  const [activeElement, setActiveElement] = useState(ImgTeacher1)
  const [activeIndex, setActiveIndex] = useState(0)

  const items = useMemo(() => {
    return [
      ImgTeacher1,
      ImgTeacher2,
      ImgTeacher3,
      ImgTeacher4,
      ImgTeacher5,
      ImgTeacher6,
      ImgTeacher7,
      ImgTeacher8,
      ImgTeacher9,
      ImgTeacher10,
    ]
  }, [])

  const onClick = useCallback((index: number, Img: string) => {
    timerKey = index

    setActiveIndex(index)

    setActiveElement(Img)
  }, [])

  useEffect(() => {
    const timeout = setInterval(() => {
      if (timerKey === 9) {
        setActiveElement(items[0])

        setActiveIndex(0)

        timerKey = 0
      } else {
        timerKey += 1
        setActiveIndex(timerKey)

        setActiveElement(items[timerKey])
      }
    }, 3000)

    return () => {
      clearInterval(timeout)
    }
  }, [])

  return {
    activeElement,
    items,
    onClick,
    activeIndex,
  }
}
